/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CompanyDailyNavConfigComp = {
  comp_type: CompanyDailyNavConfigComp.comp_type;
  cap_iq_id: string;
  ticker_symbol: string;
  company_name: string;
  /**
   * Alexandria company profile this comp's market data is pulled from. Snapshotted onto the version like the other identity fields. Null when Alexandria has no profile for the comp, or the comp predates linkage -- such a comp still prices off cap_iq_id.
   */
  alexandria_id?: string | null;
  order: number;
};
export namespace CompanyDailyNavConfigComp {
  export enum comp_type {
    PUBLIC_COMP = 'public_comp',
    ETF = 'etf',
  }
}

